module.exports = __webpack_public_path__ + "img/xlsx.63dfc363.svg";